import { FormSectionHandler } from '../entity.handler';
import { AssetResponse, AssetUpdateRequest, EventTargetFilter } from '@key-telematics/fleet-api-client';
import { AdminEditorService } from '../../admin.service';
import { FormBuilderField, FormBuilderKeyValue } from 'app/shared/components/form-builder';
import { CheckListField, EntityUtils } from '../utils';

interface EditorValues {
    zones: EventTargetFilter[];
    borders: string[];
}


export class AssetZonesSectionHandler implements FormSectionHandler<AssetResponse, EditorValues> {

    type = 'form';
    icon = 'route';
    bulk = true;

    title = this.translate('TITLE');
    description = this.translate('DESC');

    private borderValues: FormBuilderKeyValue[] = [
        { key: 'country', value: this.translate('BORDER_VALUES.COUNTRY') },
        { key: 'state', value: this.translate('BORDER_VALUES.STATE') },
    ];

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ASSET.ZONES.${key}`, values);
    }

    applyUpdate(entity: AssetResponse, payload: AssetUpdateRequest): Promise<AssetResponse> {
         return this.admin.applyUpdate(api => api.entities.updateAsset(entity.id, payload));
    }

    mapEntityToEditor(entity: AssetResponse): Promise<EditorValues> {
        return Promise.resolve({
            zones: (entity.zones || []).map(zone => ({
                targetType: 'zone',
                targetTypeId: zone.zoneType,
                targetTypeName: zone.zoneType,
                targetSelectionType: zone.targetSelectionType,
                targetId: zone.targetId,
                targetName: zone.targetName,
                text: zone.targetName,
            })),
            borders: (entity.parameters && entity.parameters.borders) || [],
        });
    }

    mapEditorToEntity(entity: AssetUpdateRequest, values: EditorValues): Promise<AssetUpdateRequest> {
        entity.parameters = entity.parameters || {};
        entity.parameters.borders = values.borders;

        if (values.zones) {
            entity.zones = values.zones.map(zone => ({
                zoneType: zone.targetTypeId as any,
                targetSelectionType: zone.targetSelectionType,
                targetId: zone.targetId,
                targetName: zone.targetName || zone.text,
            }));
        }

        return Promise.resolve(entity);
    }

    getFields(entity: AssetResponse): Promise<FormBuilderField[]> {
        return Promise.resolve([
            { type: 'zonefilter', id: 'zones', title: this.translate('FIELDS.ZONES'), required: false, getText: (field, values) => (values[field.id] || []).map(x => x.text) },
            {
                ...CheckListField('borders', this.translate('FIELDS.BORDERS'), false, this.borderValues), description: this.translate('FIELDS.BORDERS_DESC'),
                getText: (field, values) => (values[field.id] || []).map(x => this.borderValues.find(bv => bv.key === x).value),
            },
        ]).then(fields => EntityUtils.prepareBulk(!entity, ['zones', 'borders'], fields));
    }
}
